var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDigisalesV2(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.355469 5.17006C0.355469 2.66528 2.38599 0.634766 4.89076 0.634766H23.032C25.5367 0.634766 27.5672 2.66529 27.5672 5.17006V23.3113C27.5672 25.816 25.5367 27.8465 23.032 27.8465H4.89076C2.38599 27.8465 0.355469 25.816 0.355469 23.3112V5.17006Z",
    fill: "#FFAB09"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_49865_59508)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3496 18.4947L15.0305 20.1756C15.196 20.3412 15.3926 20.4725 15.6089 20.5621C15.8252 20.6517 16.057 20.6978 16.2911 20.6978C16.5253 20.6978 16.7571 20.6517 16.9734 20.5621C17.1897 20.4725 17.3862 20.3412 17.5518 20.1756C17.7173 20.0101 17.8487 19.8135 17.9383 19.5972C18.0279 19.3809 18.074 19.1491 18.074 18.915C18.074 18.6808 18.0279 18.449 17.9383 18.2327C17.8487 18.0164 17.7173 17.8198 17.5518 17.6543",
    stroke: "white",
    strokeWidth: 1.46694,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8698 15.9757L17.9709 18.0768C18.3052 18.4111 18.7587 18.599 19.2315 18.599C19.7044 18.599 20.1578 18.4111 20.4922 18.0768C20.8265 17.7424 21.0144 17.289 21.0144 16.8161C21.0144 16.3433 20.8265 15.8898 20.4922 15.5555L17.2313 12.2946C16.7585 11.8224 16.1177 11.5572 15.4496 11.5572C14.7814 11.5572 14.1406 11.8224 13.6678 12.2946L12.9283 13.0342C12.5939 13.3685 12.1404 13.5563 11.6676 13.5563C11.1948 13.5563 10.7413 13.3685 10.4069 13.0342C10.0726 12.6998 9.88477 12.2463 9.88477 11.7735C9.88477 11.3007 10.0726 10.8472 10.4069 10.5129L12.7686 8.15123C13.5352 7.38655 14.5351 6.89944 15.6098 6.76701C16.6845 6.63457 17.7727 6.86438 18.702 7.42005L19.0971 7.65537C19.4549 7.87135 19.8804 7.94626 20.2905 7.86548L21.7528 7.57133",
    stroke: "white",
    strokeWidth: 1.46694,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7584 6.73047L22.5988 15.9753H20.918",
    stroke: "white",
    strokeWidth: 1.46694,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6295 6.73047L5.78906 15.9753L11.2519 21.4381C11.5862 21.7724 12.0397 21.9603 12.5125 21.9603C12.9854 21.9603 13.4389 21.7724 13.7732 21.4381C14.1075 21.1037 14.2954 20.6503 14.2954 20.1774C14.2954 19.7046 14.1075 19.2511 13.7732 18.9168",
    stroke: "white",
    strokeWidth: 1.46694,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.11523 7.57031H13.1154",
    stroke: "white",
    strokeWidth: 1.46694,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_49865_59508"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.3368,
    height: 18.3368,
    fill: "white",
    transform: "translate(5.02148 5.12891)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDigisalesV2);
export default __webpack_public_path__ + "static/media/digisalesV2.0d7db8c50f4ccdd9e7f9f13f0674f18f.svg";
export { ForwardRef as ReactComponent };